import type { ReactNode } from "react";

import { formatPence } from "utils/format";

import ReadMore from "components/read-more";

import css from "./job-listing.module.css";

type Props = {
  body: string;
  location: string;
  payMax: number;
  payMin: number;
  title: string;
  action?: ReactNode;
  className?: string;
  expanded?: boolean;
};

const JobListing = ({
  action,
  className = "",
  expanded = false,
  title,
  location,
  payMin,
  payMax,
  body,
}: Props) => {
  const doc = new DOMParser().parseFromString(body, "text/html");
  const firstParagraph = doc.querySelector("p");
  const short = firstParagraph ? firstParagraph.innerHTML : body;
  const payDescription = `${formatPence(payMin)} - ${formatPence(payMax)}`;

  return (
    <div className={`${className} pa3 bg-white br2 koru-shadow-2`}>
      <h1 className="mb2 lh-title header-dark">{title}</h1>
      <div className="mb2 f6 lh-copy">
        {location}
        <br />
        {payDescription}
      </div>

      {expanded ? (
        <div
          dangerouslySetInnerHTML={{
            __html: body,
          }}
          className={`${css.richText} lh-copy body-medium f5`}
        />
      ) : (
        // @ts-expect-error ReadMore api has changed
        <ReadMore
          className={`${css.richText} lh-copy body-medium f5`}
          full={
            <div
              dangerouslySetInnerHTML={{
                __html: body,
              }}
            />
          }
          linkClasses="link rose mt2 db"
          short={
            <div
              dangerouslySetInnerHTML={{
                __html: short,
              }}
            />
          }
        />
      )}
      {action}
    </div>
  );
};

export default JobListing;
